export default __webpack_public_path__ + "static/media/logo.cbb3c08f.svg";